import { Controller, useForm } from "react-hook-form";
import { Popup } from "@/components/popups/Popup";
import { ToggleButton } from "@/components/buttons/ToggleButton";
import "./styles/CreateNewCollectionPopup.scss";
import { useAddUserCollectionMutation } from "@/common/queries/queries";
import { ICreateCollection } from "@/common/services/types";
import { TextInput } from "@/components/inputs/TextInput/TextInput";
import { TextArea } from "@/components/inputs/TextArea/TextArea";
import { showNotification } from "@/components/alerts/Notifications";

interface ICreateNewCollectionPopupProps {
  isOpen: boolean;
  togglePopup: () => void;
}

interface IForm {
  published: boolean;
  description: string;
  folderName: string;
}

export const CreateNewCollectionPopup = ({ isOpen, togglePopup }: ICreateNewCollectionPopupProps) => {
  const { control, handleSubmit } = useForm<IForm>();
  const addUserCollectionMutation = useAddUserCollectionMutation();

  const onSubmit = async (data: IForm) => {
    const dataToSend: ICreateCollection = {
      published: !data.published,
      description: data.description || null,
      folderName: data.folderName
    };

    try {
      await addUserCollectionMutation.mutateAsync(dataToSend);
      showNotification({
        variant: "success",
        title: "Successfully created."
      });
    } catch (e) {
      showNotification({
        variant: "error",
        title: "Something went wrong. Please try later."
      });
    } finally {
      togglePopup();
    }
  };

  const btnProps = {
    variant: 1,
    title: "Create",
    formId: "create-collection-form",
    btnType: "submit"
  };

  return (
    <Popup
      isOpen={isOpen}
      onClose={togglePopup}
      title="Create a Collection"
      popupClass="CreateNewCollectionPopup"
      btnProps={btnProps}
    >
      <form onSubmit={handleSubmit(onSubmit)} id="create-collection-form">
        <Controller
          name="folderName"
          control={control}
          defaultValue=""
          rules={{ required: "Required Field!" }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextInput
              label="Collection name"
              onChange={onChange}
              value={value}
              error={error?.message}
            />
          )}
        />

        <Controller
          name="description"
          control={control}
          defaultValue=""
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextArea label="Description" onChange={onChange} value={value} rows={3} error={error?.message}/>
          )}
        />

        <div className="CreateNewCollectionPopup-Toggle">
          <p>Make private</p>
          <Controller
            name="published"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value } }) => (
              <ToggleButton checked={value} onChange={onChange}/>
            )}
          />
        </div>
      </form>
    </Popup>
  );
};

